import React, { useEffect, useState } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import swal from "sweetalert";
import AnimatedPage from "../components/AnimatedPage";
import Header from "../components/Header";
import Footer from "../components/Footer";

function WithDraw() {
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const [bank, setBank] = useState(null);
    const [setting, setSetting] = useState(JSON.parse(localStorage.getItem("setting")));
    
    // State cho Form
    const [newMoney, setNewMoney] = useState(null);
    const [load, setLoad] = useState(false);
    
    const navigate = useNavigate();

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    const {
        register,
        handleSubmit,
        setError,
        formState: { errors }
    } = useForm();

    useEffect(() => {
        // Lấy thông tin User
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
            .then((res) => {
                if (profile !== res.data.data) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
            })
            .catch((err) => localStorage.removeItem("user"));
            
        // Lấy danh sách ngân hàng của User
        axios
            .get(`${process.env.REACT_APP_API_URL}/bank/getBank`, {})
            .then((res) => {
                const userBanks = res.data.data;
                // Nếu User chưa liên kết ngân hàng nào -> Điều hướng luôn sang trang AddBank
                if (!userBanks || userBanks.length === 0) {
                    swal("Thông báo", "Vui lòng liên kết ngân hàng trước khi rút điểm", "warning")
                    .then(() => navigate("/addbank"));
                } else {
                    setBank(userBanks);
                }
            })
            .catch((err) => setBank(null));
            
        // Lấy setting (min/max rút)
        axios.get(`${process.env.REACT_APP_API_URL}/setting/get`, {}).then((res) => {
            if (setting !== res.data.data[0]) {
                setSetting(res.data.data[0]);
                localStorage.setItem("setting", JSON.stringify(res.data.data[0]));
            }
        });
    }, [navigate]);

    // Hàm ẩn 4 số cuối của Số tài khoản
    const maskBankAccount = (stk) => {
        if (!stk) return "";
        if (stk.length <= 4) return "****";
        return stk.slice(0, -4) + "****";
    };

    const onSubmit = (data) => {
        if (load === true) return false;
        
        // Lấy số điểm nhập vào (VD: 100)
        const inputPoint = Number(data.money.replaceAll(".", "").replaceAll(",", ""));
        
        // Tính ra tiền thật (VD: 100 * 1000 = 100000)
        const realMoney = inputPoint * 1000;

        if (realMoney > profile.money) {
            setError("money", { type: "minLength", message: "Số dư điểm không đủ" });
            return false;
        }
        if (inputPoint <= 0 || isNaN(inputPoint)) {
            setError("money", { type: "minLength", message: "Vui lòng nhập số điểm hợp lệ" });
            return false;
        }
        if (!data.paypwd) {
            setError("paypwd", { type: "minLength", message: "Vui lòng nhập mật khẩu rút tiền" });
            return false;
        }
        if (realMoney < setting?.minrut) {
            swal("Chú ý", `Số điểm rút tối thiểu là ${(setting?.minrut / 1000).toLocaleString('vi-VN')} Điểm`, "warning");
            return false;
        }
        if (realMoney > setting?.maxrut) {
            swal("Chú ý", `Số điểm rút tối đa là ${(setting?.maxrut / 1000).toLocaleString('vi-VN')} Điểm`, "warning");
            return false;
        }

        // Bỏ dropdown chọn ngân hàng, tự động lấy ngân hàng duy nhất của user
        if (!bank || bank.length === 0) {
            swal("Chú ý", "Vui lòng liên kết ngân hàng trước khi rút", "warning");
            return false;
        }
        
        const selectedBank = bank[0];
        const detailString = `${selectedBank.name_bank} - ${selectedBank.fullname} - ${selectedBank.stk}`;

        const formData = {
            money: realMoney,
            type_payment: "RÚT",
            detail: detailString,
            status_payment: "Pending",
            user: profile._id,
            paypwd: data.paypwd
        };
        
        setLoad(true);
        axios
            .post(`${process.env.REACT_APP_API_URL}/payment/withDraw`, formData)
            .then((res) => {
                swal({
                    title: "Thông báo",
                    text: "Tạo yêu cầu rút điểm thành công!",
                    icon: "success",
                    buttons: "OK"
                }).then(() => navigate("/profile"));
            })
            .catch((err) => {
                swal("Thất bại", err.response?.data?.message !== "internal server error" ? err.response.data.message : "Đã có lỗi xảy ra", "error");
                setLoad(false);
            });
    };

    return (
        <AnimatedPage>
            <Header profile={profile} />

            <style>{`
                html, body, #root {
                    height: auto !important;
                    min-height: 100vh;
                    overflow-y: auto !important;
                    background-color: #e3e1e2 !important; 
                    margin: 0; padding: 0;
                }
                
                .withdraw-wrapper {
                    padding-bottom: 100px;
                    background-color: #e3e1e2;
                    min-height: 100vh;
                }

                /* ================================================== */
                /* 1. THÔNG TIN USER                                  */
                /* ================================================== */
                .center-head {
                    width: 100%;
                    height: 180px;
                    background: url('https://dztwieyphe62d.cloudfront.net/content/images/main/user/banner-center.jpg') center top no-repeat;
                    background-size: cover;
                    padding: 0 20px; 
                    display: flex;
                    align-items: center; 
                    color: #fff;
                    box-shadow: 0 2px 5px rgba(0,0,0,0.2);
                }
                .profile-avatar-wrapper { position: relative; margin-right: 15px; flex-shrink: 0; }
                .profile-avatar { width: 65px; height: 65px; background-color: #fff; border-radius: 50%; display: flex; justify-content: center; align-items: center; }
                .profile-avatar i { font-size: 38px; color: #ffca28; }
                .profile-v1-badge { position: absolute; top: -2px; right: -5px; background-color: #ff9800; color: #fff; border-radius: 50%; width: 20px; height: 20px; display: flex; justify-content: center; align-items: center; font-size: 11px; font-weight: bold; border: 2px solid #222; }
                .profile-info { flex: 1; display: flex; flex-direction: column; justify-content: center; text-align: left; }
                .profile-info h3 { margin: 0 0 2px 0; font-size: 16px; font-weight: bold; color: #fff; }
                .profile-info p.email { margin: 0 0 6px 0; font-size: 13px; color: #ddd; }
                .profile-stats p { margin: 2px 0; font-size: 13px; color: #fff; }
                .profile-stats span { color: #ff9800; font-weight: bold; }

                /* ================================================== */
                /* 2. CÁC TAB CHÍNH VÀ NÚT CHỌN NGÂN HÀNG             */
                /* ================================================== */
                .wd-content { padding: 15px; }

                .r-tabs { display: flex; gap: 5px; margin-bottom: 20px; }
                .r-tab { flex: 1; padding: 12px; text-align: center; background: #fff; border-radius: 25px; font-size: 14px; font-weight: bold; color: #333; cursor: pointer; border: 1px solid #ddd; }
                .r-tab.active { background: #b71c1c; color: #fff; border-color: #b71c1c; box-shadow: 0 2px 4px rgba(0,0,0,0.2); }

                /* Nút Bank viền đỏ */
                .bank-method-btn {
                    width: 100px;
                    border: 2px solid #d32f2f;
                    background: #fff;
                    border-radius: 6px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    padding: 10px 5px;
                    margin-bottom: 25px;
                    cursor: pointer;
                }
                .bank-method-btn i { font-size: 24px; color: #fbc02d; margin-bottom: 5px; }
                .bank-method-btn span { font-size: 12px; font-weight: bold; color: #1174c3; }

                /* ================================================== */
                /* 3. BẢNG THÔNG TIN NGÂN HÀNG (MÀU GHI NHẠT)         */
                /* ================================================== */
                .wd-title-section {
                    font-size: 18px;
                    font-weight: bold;
                    color: #555;
                    margin-bottom: 10px;
                }
                .info-table {
                    width: 100%;
                    border-collapse: collapse;
                    margin-bottom: 20px;
                    font-size: 13px;
                }
                .info-table td {
                    padding: 12px 0;
                    border-bottom: 1px solid #ccc;
                    color: #555;
                }
                .info-table td:nth-child(2) {
                    text-align: right;
                    font-weight: bold;
                    color: #333;
                }

                /* ================================================== */
                /* 4. PHƯƠNG THỨC RÚT TIỀN (RADIO & NÚT THÊM BANK)    */
                /* ================================================== */
                .wd-header-row {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    margin-bottom: 15px;
                }
                .btn-add-bank-small {
                    background: #2196f3; /* Màu xanh biển */
                    color: #fff;
                    border: none;
                    border-radius: 4px;
                    padding: 6px 10px;
                    font-size: 12px;
                    font-weight: bold;
                    cursor: pointer;
                    text-decoration: none;
                }
                
                .radio-bank-group {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    margin-bottom: 25px;
                }
                .radio-bank-group input { width: 18px; height: 18px; accent-color: #2196f3; }
                .radio-bank-group label { font-size: 14px; font-weight: bold; color: #444; }

                /* ================================================== */
                /* 5. THỐNG KÊ (SỐ DƯ, GIỚI HẠN, SỐ LẦN)              */
                /* ================================================== */
                .wd-stats-grid {
                    display: grid;
                    grid-template-columns: 1fr 1fr 1fr;
                    gap: 10px;
                    margin-bottom: 25px;
                }
                .wd-stat-item {
                    display: flex;
                    flex-direction: column;
                }
                .wd-stat-label { font-size: 12px; font-weight: bold; color: #555; margin-bottom: 5px; }
                .wd-stat-value { font-size: 13px; color: #777; }

                /* ================================================== */
                /* 6. FORM RÚT TIỀN DƯỚI CÙNG                         */
                /* ================================================== */
                .wd-form-group {
                    margin-bottom: 15px;
                }
                .wd-form-group label {
                    display: block;
                    font-size: 14px;
                    font-weight: bold;
                    color: #555;
                    margin-bottom: 8px;
                }
                .wd-input {
                    width: 100%;
                    padding: 12px 15px;
                    border: 1px solid #ccc;
                    border-radius: 4px;
                    font-size: 14px;
                    outline: none;
                    background: #fff;
                    color: #333;
                }
                .wd-currency {
                    font-size: 13px;
                    font-weight: bold;
                    color: #00b459; /* Màu xanh lá cho số tiền thực nhận */
                    margin-top: 5px;
                    display: block;
                }
                .error-text {
                    color: #d32f2f;
                    font-size: 12px;
                    margin-top: 4px;
                    display: block;
                }
            `}</style>

            <div className="withdraw-wrapper">
                
                {/* 1. BANNER THÔNG TIN */}
                <div className="center-head">
                    <div className="profile-avatar-wrapper">
                        <div className="profile-avatar">
                            <i className="fa-solid fa-user"></i>
                        </div>
                        <span className="profile-v1-badge">v1</span>
                    </div>
                    <div className="profile-info">
                        <h3>{profile?.username}</h3>
                        <div className="profile-stats">
                          <p>Mã mời : <span>{profile.code}</span></p>
                            <p>Số dư : <span>{profile?.money ? Math.floor(profile.money / 1000).toLocaleString("vi-VN") : "0"} Điểm</span></p>
                        </div>
                    </div>
                </div>

                <div className="wd-content">
                    
                    {/* 2. TABS */}
                    <div className="r-tabs">
                        <div className="r-tab active">Rút điểm</div>
                        <div className="r-tab" onClick={() => navigate("/withdraw_record")}>Lịch sử rút</div>
                    </div>

                    {/* NÚT NGÂN HÀNG VIỀN ĐỎ */}
                    <div className="bank-method-btn">
                        <i className="fa-solid fa-building-columns"></i>
                        <span>Ngân hàng</span>
                    </div>

                    {/* NẾU ĐÃ CÓ NGÂN HÀNG */}
                    {bank && bank.length > 0 && (
                        <form onSubmit={handleSubmit(onSubmit)}>
                            
                            {/* 3. BẢNG THÔNG TIN NGÂN HÀNG MẶC ĐỊNH (Lấy bank đầu tiên) */}
                            <div className="wd-title-section">Thông tin ngân hàng</div>
                            <table className="info-table">
                                <tbody>
                                    <tr>
                                        <td>Tên thật :</td>
                                        <td style={{ textTransform: "uppercase" }}>{bank[0]?.fullname}</td>
                                    </tr>
                                    <tr>
                                        <td>Tên ngân hàng :</td>
                                        <td>{bank[0]?.name_bank}</td>
                                    </tr>
                                    <tr>
                                        <td>Số tài khoản :</td>
                                        <td>{maskBankAccount(bank[0]?.stk)}</td>
                                    </tr>
                                </tbody>
                            </table>

                            {/* 4. PHƯƠNG THỨC RÚT TIỀN & THÊM BANK */}
                            <div className="wd-header-row">
                                <div className="wd-title-section" style={{ margin: 0 }}>Phương thức nhận tiền</div>
                            </div>

                            <div className="radio-bank-group">
                                <input type="radio" checked readOnly />
                                <label>{bank[0]?.name_bank}</label>
                            </div>

                            {/* 5. THỐNG KÊ RÚT TIỀN (Quy đổi ra Điểm) */}
                            <div className="wd-stats-grid">
                                <div className="wd-stat-item">
                                    <span className="wd-stat-label">Số dư</span>
                                    <span className="wd-stat-value">{profile?.money ? Math.floor(profile.money / 1000).toLocaleString("vi-VN") : "0"} Điểm</span>
                                </div>
                                <div className="wd-stat-item">
                                    <span className="wd-stat-label">Giới hạn rút</span>
                                    <span className="wd-stat-value">
                                        {setting?.minrut ? Math.floor(setting.minrut / 1000).toLocaleString("vi-VN") : "0"} ~ {setting?.maxrut ? Math.floor(setting.maxrut / 1000).toLocaleString("vi-VN") : "0"}
                                    </span>
                                </div>
                                <div className="wd-stat-item">
                                    <span className="wd-stat-label">Số lần rút</span>
                                    <span className="wd-stat-value">3 lần/ 1 ngày</span>
                                </div>
                            </div>

                            {/* 6. FORM RÚT TIỀN */}
                            <div className="wd-form-group">
                                <label>
                                    Số điểm rút <small style={{ color: "#888", fontWeight: "normal" }}>(1 Điểm = 1.000 VNĐ)</small>
                                </label>
                                <input
                                    className="wd-input"
                                    type="text"
                                    placeholder="Ví dụ muốn rút 100.000đ thì nhập 100"
                                    value={newMoney || ""}
                                    {...register("money", { required: true })}
                                    onClick={() => setNewMoney(null)}
                                    onChange={(e) => {
                                        const raw = e.target.value.replaceAll(".", "").replaceAll(",", "");
                                        if (!isNaN(raw) && raw !== "") {
                                            setNewMoney(Number(raw).toLocaleString('vi-VN'));
                                        } else {
                                            setNewMoney("");
                                        }
                                    }}
                                />
                                {/* Hint hiện số tiền thật ra cho người chơi đỡ nhầm */}
                                <span className="wd-currency">
                                    Thực nhận: {newMoney ? (Number(newMoney.replaceAll(".", "").replaceAll(",", "")) * 1000).toLocaleString("vi-VN") : "0"} VNĐ
                                </span>
                                {errors.money && <span className="error-text">{errors.money.message}</span>}
                            </div>

                            <div className="wd-form-group">
                                <label>Mật khẩu rút tiền</label>
                                <input
                                    className="wd-input"
                                    type="password"
                                    placeholder="Nhập mật khẩu rút tiền"
                                    {...register("paypwd", { required: true })}
                                />
                                {errors.paypwd && <span className="error-text">{errors.paypwd.message}</span>}
                            </div>

                            <button 
                                type="submit" 
                                disabled={load}
                                style={{
                                    width: "100%", background: "#b71c1c", color: "#fff", fontWeight: "bold",
                                    padding: "14px", border: "none", borderRadius: "5px", fontSize: "16px",
                                    cursor: "pointer", marginTop: "10px"
                                }}
                            >
                                {load ? "Đang xử lý..." : "Xác nhận Rút điểm"}
                            </button>
                        </form>
                    )}

                </div>
            </div>
            
            <Footer />
        </AnimatedPage>
    );
}

export default WithDraw;